import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import AgeGate from "./components/AgeGate";
import GeoGuard from "./components/GeoGuard";
import ProtectedRoute from "./components/ProtectedRoute";
import InstallBanner from "./components/InstallBanner";

import Landing from "./pages/Landing";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import AdminChat from "./pages/AdminChat";
import AdminDeposits from "./pages/AdminDeposits";
import AdminGameConfig from "./pages/AdminGameConfig";
import AdminGames from "./pages/admin/AdminGames";
import AdminImageLibrary from "./pages/AdminImageLibrary";
import AdminKpis from "./pages/AdminKpis";
import AdminKyc from "./pages/AdminKyc";
import AdminPlayers from "./pages/AdminPlayers";
import AdminProviders from "./pages/AdminProviders";
import AdminRgPolicy from "./pages/AdminRgPolicy";
import AdminTransactions from "./pages/AdminTransactions";
import AdminWithdrawals from "./pages/AdminWithdrawals";
import BonusManager from "./pages/admin/BonusManager";
import AdminSportsbook from "./pages/admin/AdminSportsbook";
import Blocked from "./pages/Blocked";
import ResponsibleGambling from "./pages/ResponsibleGambling";
import History from "./pages/History";
import Game from "./pages/Game";
import Verify from "./pages/Verify";
import WalletLayout from "./pages/WalletLayout";
import WalletDeposit from "./pages/WalletDeposit";
import WalletWithdraw from "./pages/WalletWithdraw";
import WalletKyc from "./pages/WalletKyc";
import Promotions from "./pages/Promotions";
import Sportsbook from "./pages/Sportsbook";
import Vip from "./pages/Vip";
import Download from "./pages/Download";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CurrencyProvider>
        <AgeGate />
        <InstallBanner />
        <GeoGuard>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/blocked" element={<Blocked />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/download" element={<Download />} />
            <Route path="/game-poc" element={<Navigate to="/game/bra-3-way" replace />} />
            <Route path="/game" element={<Navigate to="/game/bra-3-way" replace />} />

            {/* player-protected */}
            <Route
              path="/game/:slug"
              element={
                <ProtectedRoute>
                  <Game />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings/responsible-gambling"
              element={
                <ProtectedRoute>
                  <ResponsibleGambling />
                </ProtectedRoute>
              }
            />
            <Route
              path="/history"
              element={
                <ProtectedRoute>
                  <History />
                </ProtectedRoute>
              }
            />
            <Route
              path="/promotions"
              element={
                <ProtectedRoute>
                  <Promotions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vip"
              element={
                <ProtectedRoute>
                  <Vip />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sportsbook"
              element={
                <ProtectedRoute>
                  <Sportsbook />
                </ProtectedRoute>
              }
            />

            {/* Wallet — nested */}
            <Route
              path="/wallet"
              element={
                <ProtectedRoute>
                  <WalletLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={null} />
              <Route path="deposit" element={<WalletDeposit />} />
              <Route path="withdraw" element={<WalletWithdraw />} />
              <Route path="kyc" element={<WalletKyc />} />
            </Route>

            {/* admin-protected — nested Outlet handles subroutes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly>
                  <Admin />
                </ProtectedRoute>
              }
            >
              <Route path="players" element={<AdminPlayers />} />
              <Route path="deposits" element={<AdminDeposits />} />
              <Route path="withdrawals" element={<AdminWithdrawals />} />
              <Route path="kyc" element={<AdminKyc />} />
              <Route path="providers" element={<AdminProviders />} />
              <Route path="transactions" element={<AdminTransactions />} />
              <Route path="game-config" element={<AdminGameConfig />} />
              <Route path="games" element={<AdminGames />} />
              <Route path="image-library" element={<AdminImageLibrary />} />
              <Route path="rg-policy" element={<AdminRgPolicy />} />
              <Route path="bonuses" element={<BonusManager />} />
              <Route path="sportsbook" element={<AdminSportsbook />} />
              <Route path="chat" element={<AdminChat />} />
              <Route path="kpis" element={<AdminKpis />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </GeoGuard>
        </CurrencyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
